import {Directive, ElementRef, Input, NgModule, OnDestroy, OnInit, Renderer2} from '@angular/core';
import { CommonModule } from '@angular/common';

@Directive({
  selector: '[lcmsAvatarAsLetter]',
})
export class AvatarAsLetterDirective implements OnInit, OnDestroy {
  @Input() email!: any;
  @Input() border!: string;
  @Input() width!: string;
  @Input() height!: string;
  @Input() fontsize!: string;
  @Input() padding!: string;

  avatarContainer:HTMLDivElement
  constructor(private el: ElementRef) {}

  ngOnDestroy(): void {
    console.log('on destroy');
    this.avatarContainer?.remove();
  }

  ngOnInit() {
    const imgSrc = this.el.nativeElement.src;
    // console.log('CustomAvatarDirective', this.email, imgSrc);
    if (this.email) {
      const imgTest = new Image();
      imgTest.src = imgSrc;
      imgTest.onerror = () => {
        // console.log('Image does not exist or is not loaded');
        this.createAvatar(this.email);
      };
    }
  }

  createAvatar(email: string) {
    this.avatarContainer = document.createElement('div');
    const initials = email.slice(0,2).toUpperCase();
    const colors = [
      ['#F94144', '#F9DDDD'], // Color for A
      ['#F8961E', '#FDEDD4'], // Color for B
      ['#F9C74F', '#FEF5E7'], // Color for C
      ['#90BE6D', '#F0FFF4'], // Color for D
      ['#43AA8B', '#F0FFF4'], // Color for E
      ['#577590', '#F0F4F9'], // Color for F
      ['#277DA1', '#F4F9FD'], // Color for G
      ['#6D597A', '#F9F6F0'], // Color for H
      ['#364156', '#F9F6F0'], // Color for I
      ['#22223B', '#F9F6F0'], // Color for J
      ['#4A4E69', '#F9F6F0'], // Color for K
      ['#C9ADA7', '#F9F6F0'], // Color for L
      ['#D4AF37', '#FDF5D7'], // Color for M
      ['#2E2E2E', '#F9F6F0'], // Color for N
      ['#FFD700', '#FFFACD'], // Color for O
      ['#DAA520', '#FDF5CE'], // Color for P
      ['#CD7F32', '#FDF5E6'], // Color for Q
      ['#8B4513', '#FDF5E6'], // Color for R
      ['#800000', '#FDF2E9'], // Color for S
      ['#008080', '#F0FFF4'], // Color for T
      ['#800080', '#FDF2F8'], // Color for U
      ['#B22222', '#FDF2F0'], // Color for V
      ['#00FFFF', '#F0FFFF'], // Color for W
      ['#FF00FF', '#FFF0FF'], // Color for X
      ['#FFFF00', '#FFFFE0'], // Color for Y
      ['#008000', '#F0FFF0'], // Color for Z
    ];

    const letter = initials;
    const colorIndex = letter.charCodeAt(0) - 65;
    const color = colors[colorIndex];
    this.avatarContainer.classList.add('avatar','d-flex','justify-content-center','align-items-center');
    this.avatarContainer.innerText = letter;
    this.avatarContainer.style.backgroundColor = color[0];
    this.avatarContainer.style.color = color[1];
    this.avatarContainer.style.float = 'left';
    this.avatarContainer.style.boxSizing = 'border-box';
    this.avatarContainer.style.fontSize = this.fontsize ?? '25px';
    this.avatarContainer.style.padding = this.padding;
    this.avatarContainer.style.textAlign = 'center';
    this.avatarContainer.style.width = this.width ?? '50px';
    this.avatarContainer.style.height = this.height ?? '50px';
    this.avatarContainer.style.borderRadius = this.border ?? '50px';
    this.avatarContainer.style.overflow = 'hidden';
    this.el.nativeElement.style.display = 'none';
    this.el.nativeElement.parentNode.insertBefore(this.avatarContainer, this.el.nativeElement);
  }
}


@NgModule({
  imports: [CommonModule],
  declarations: [AvatarAsLetterDirective],
  exports: [AvatarAsLetterDirective],
})
export class AvatarAsLetterDirectiveModule {}
